module.exports = __webpack_public_path__ + "static/img/manual-9.5589adb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-9.png
// module id = 42ww
// module chunks = 4